<template>
  <div>
    <v-alert
      dense
      text
      type="info"
      class="mb-5"
    >
      Luovutettavat osuudet on ilmoitettava samalla tavalla,
      kuin ne on kirjattu Maanmittauslaitokselle
    </v-alert>

    <div
      v-for="(osuus, idx) of body.luovutettavatOsuudet"
      :key="idx"
      class="pb-4"
    >
      <div class="mb-3 helmi-card-title">
        Osuus {{ idx + 1 }}
      </div>

      <v-text-field
        v-model="osuus.osuus"
        label="Osuus"
        :rules="[rules.required, rules.fraction]"
        append-outer-icon="clear"
        @click:append-outer="remove(idx)"
      />

      <template v-for="(seller, sellerIdx) of body.sellers">
        <template v-if="seller.roles.includes('ORGANIZATION')">
          <v-checkbox
            :key="sellerIdx"
            v-model="osuus.sellerBusinessIds"
            :rules="[selections(osuus)]"
            :label="`${seller.organization.name} (${seller.organization.businessId})`"
            :value="seller.organization.businessId"
            hide-details
          />
        </template>

        <template v-else-if="seller.roles.includes('SIGNER')">
          <v-checkbox
            :key="sellerIdx"
            v-model="osuus.sellerSocialSecurityNumbers"
            :rules="[selections(osuus)]"
            :label="`${seller.person.firstName} ${seller.person.lastName}
            (${seller.person.socialSecurityNumber})`"
            :value="seller.person.socialSecurityNumber"
            hide-details
          />
        </template>
      </template>

      <v-divider
        v-if="idx < body.luovutettavatOsuudet.length - 1
          && body.luovutettavatOsuudet.length > 1"
        class="mt-6 mb-2"
      />
    </div>
    <v-btn
      depressed
      color="primary"
      class="mt-3"
      @click="addRow()"
    >
      Lisää osuus
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    body: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    rules: {
      required: value => value?.length > 0 || 'Pakollinen kenttä.',
      fraction: (value) => {
        const pattern = /(?:[1-9][0-9]*|0)\/[1-9][0-9]*/g;
        return pattern.test(value) || 'Virheellinen murtoluku.';
      },
    },
  }),
  methods: {
    selections(osuus) {
      const hasSelections = osuus.sellerBusinessIds?.length > 0
          || osuus.sellerSocialSecurityNumbers?.length > 0;

      return hasSelections || 'Pakollinen kenttä.';
    },
    addRow() {
      this.body.luovutettavatOsuudet.push({
        osuus: '',
        sellerSocialSecurityNumbers: [],
        sellerBusinessIds: [],
      });
    },
    remove(idx) {
      this.body.luovutettavatOsuudet.splice(idx, 1);
    },
  },
};
</script>
